import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import PageLoading from './PageLoading';

/** Where a signed-in member's app starts: the business dashboard or opportunities. */
export const memberHomePath = (profile) => (
    profile?.accountType === 'business' || profile?.type === 'business' ? '/business/dashboard' : '/opportunities'
);

/**
 * For pages meant for signed-out visitors (landing, login): signed-in members are sent into the
 * app instead. A shared post link (?postId=) opens the post in the feed.
 */
export default function MemberRedirect({ children }) {
    const { authUser, isMember, profile } = useAuth();
    const location = useLocation();
    if (!authUser || !isMember) return children;

    const postId = new URLSearchParams(location.search).get('postId');
    if (postId) return <Navigate to={`/feed?postId=${encodeURIComponent(postId)}`} replace />;
    // The account type comes from the profile, which loads just after sign-in is confirmed.
    if (!profile) return <PageLoading />;
    return <Navigate to={memberHomePath(profile)} replace />;
}
